.campaignMediaWrapper {
  height: 400px;
  padding: 8px;
}

@media (max-width: 950px) {
  .campaignMediaWrapper {
    height: auto;
  }
}

:global(#react-container) {
  @media (max-width: 1755px) {
    .campaignMediaWrapper {
      height: auto;
    }
  }
}
